import Agent from '../Core/agent';

const SearchApi = {
    autocomplete: async (searchPhrase) => {
        return Agent.post(
            '/api/v1/autocomplete/search/',
            new window.URLSearchParams({
                phrase: searchPhrase
            })
        );
    }
};
export default SearchApi;